import { render, staticRenderFns } from "./IndexNotOnSale.vue?vue&type=template&id=65ec6314"
import script from "./IndexNotOnSale.vue?vue&type=script&lang=js"
export * from "./IndexNotOnSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports